import { ComponentType, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import { RouterLink } from 'components/Link';
import { User } from 'modules/main/store/ducks/userEnvironment';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';

const getPath = (user?: User) => {
  if (user) {
    if (user.orgs.length === 1) {
      const org = user.orgs[0];

      if (org.isAllowedToPost && !org.isFrozen) {
        return `/admin/${org.id}/post-a-listing`;
      }

      return `/admin/${org.id}`;
    }
  }

  return '/post-a-listing';
};

type Props = {
  children: ReactNode;
  className?: string;
  component?: ComponentType<{
    children: ReactNode;
    onClick?: () => void;
    to:
      | {
          pathname: string;
          state: {
            from: string;
          };
        }
      | string;
    from?: string;
    'data-qa-id'?: string;
  }>;
  onClick?: () => void;
  'data-qa-id'?: string;
};

export function PostListingLink({
  children,
  className,
  component,
  'data-qa-id': qaId,
  onClick,
}: Props) {
  const userEnvronment = useUserEnvironment();
  const location = useLocation();
  const Component = component || RouterLink;
  const pathname = getPath(userEnvronment.user);
  return (
    <Component
      className={className}
      to={pathname}
      state={{
        from: location.pathname,
      }}
      from={location.pathname}
      data-qa-id={qaId || 'post-a-listing'}
      onClick={onClick}
    >
      {children}
    </Component>
  );
}
